import React from 'react';

import {Link, Text} from '@gravity-ui/uikit';
import {IntegrationsType} from 'common/constants/success';
import {Integration} from 'common/models/success';
import i18n from 'ui/i18n';

import {cnIntegrationItem} from './IntegrationItem.constants';
import {IntegrationItemProps, NotApiTypes} from './IntegrationItem.types';

import apiIcon from 'ui/assets/svg/apiLogo.svg';
import functionIcon from 'ui/assets/svg/functionLogo.svg';
import mailIcon from 'ui/assets/svg/mailLogo.svg';
import trackerIcon from 'ui/assets/svg/trackerLogo.svg';
import wikiIcon from 'ui/assets/svg/wikiLogo.svg';

export const renderIntegrationType = (
    type: IntegrationItemProps['type'],
    succeedData: Integration[],
) => {
    const succeedDataCount = succeedData.length;

    switch (type) {
        case IntegrationsType.Email:
            return (
                <>
                    <Text variant="subheader-2">
                        {i18n('success-page', 'emails-sent', {
                            count: succeedDataCount,
                        })}
                    </Text>

                    {succeedData.map((value) => (
                        <Text key={value.id} variant="body-2" as="div">
                            {value.to_address}
                        </Text>
                    ))}
                </>
            );

        case IntegrationsType.Wiki: {
            return (
                <>
                    <Text variant="subheader-2">
                        {i18n('success-page', 'pages-updated', {
                            count: succeedDataCount,
                            pagesCount: succeedDataCount,
                        })}
                    </Text>

                    {succeedData.map((value) => (
                        <Link
                            key={value.id}
                            target="_blank"
                            rel="noopener noreferrer"
                            href={value.link}
                        >
                            {value.wiki_page}
                        </Link>
                    ))}
                </>
            );
        }

        case IntegrationsType.Tracker: {
            return (
                <>
                    <Text variant="subheader-2">
                        {i18n('success-page', 'tasks-created', {
                            count: succeedDataCount,
                            tasksCount: succeedDataCount,
                        })}
                    </Text>

                    {succeedData.map((value) => {
                        const [ticketNumber, ticketName] = value.issue_key.split(': ');

                        return (
                            <div key={value.id}>
                                <Link
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={value.link}
                                    className={cnIntegrationItem('TicketLink')}
                                >
                                    {ticketName}
                                </Link>
                                <Text
                                    className="IntegrationItem-TicketNumber"
                                    color="secondary"
                                    as="div"
                                >
                                    {ticketNumber}
                                </Text>
                            </div>
                        );
                    })}
                </>
            );
        }
        case IntegrationsType.Function: {
            return (
                <>
                    <Text variant="subheader-2">{i18n('success-page', 'data-send')}</Text>

                    {succeedData.map((value) => (
                        <Text key={value.id} variant="body-2" as="div">
                            {value?.function_id}
                        </Text>
                    ))}
                </>
            );
        }

        case IntegrationsType.Http:
        case IntegrationsType.Post:
        case IntegrationsType.Put:
        case IntegrationsType.Jsonrpc: {
            return (
                <>
                    <Text variant="subheader-2">{i18n('success-page', 'data-send')}</Text>

                    {succeedData.map((value) => (
                        <Text key={value.id} variant="body-2" as="div">
                            {value?.url}
                        </Text>
                    ))}
                </>
            );
        }

        default:
            return null;
    }
};

const iconsMap = {
    email: mailIcon,
    wiki: wikiIcon,
    api: apiIcon,
    tracker: trackerIcon,
    function: functionIcon,
};

const apiIntegrationTypes = [
    IntegrationsType.Http,
    IntegrationsType.Post,
    IntegrationsType.Put,
    IntegrationsType.Jsonrpc,
];

export const getIntegrationTypeIcon = (type: IntegrationsType) => {
    if (apiIntegrationTypes.includes(type)) {
        return iconsMap.api;
    }

    // TODO: [ilay] refactor typings
    return iconsMap[type as NotApiTypes];
};

export const getIntegrationTypeTitle = (type: IntegrationsType) => {
    if (apiIntegrationTypes.includes(type)) {
        return 'title-api';
    }

    return `title-${type}`;
};
